import React, { useState } from 'react';
import styles from './AmazonSyncStep.module.css';
import CatalogueHealthBg from '../../../assets/dashboard_assets/catalouge-health.png';
import BookDemoModal from '../../../components/UI/BookDemoModal';

const LinkIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 13L12 7M10 6H12.5C13.163 6 13.7149 6 14.1644 6.05546C14.5975 6.10819 14.9433 6.20487 15.2426 6.41459C15.569 6.64443 15.8284 6.95398 16.0555 7.34824C16.25 7.68524 16.3884 8.07508 16.4722 8.58935C16.56 9.13648 16.56 9.76393 16.56 10.5V12M4 12V10.5C4 9.76393 4 9.13648 4.0878 8.58935C4.17164 8.07508 4.31002 7.68524 4.5045 7.34824C4.73157 6.95398 4.991 6.64443 5.31738 6.41459C5.61669 6.20487 5.96254 6.10819 6.39562 6.05546C6.84515 6 7.39697 6 8.06 6H10.5M12 14H7.5C6.83696 14 6.28514 14 5.83562 13.9445C5.40254 13.8918 5.05669 13.7951 4.75738 13.5854C4.431 13.3556 4.17157 13.046 3.9445 12.6518C3.75 12.3148 3.61164 11.9249 3.52779 11.4107C3.44 10.8635 3.44 10.2361 3.44 9.5V7" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

function AmazonSync({ onConnect, onSkip, isConnecting }) {
  const [isDemoOpen, setIsDemoOpen] = useState(false);

  return (
    <div className={styles.box}>
      <div className={styles.content}>
        <img src={CatalogueHealthBg} alt="" className={styles.illustration} />
        <div className={styles.textBlock}>
          <h2 className={styles.title}>Connect your Amazon account — you stay in control</h2>
          <p className={styles.subtitle}>
            Sign in with Amazon's official secure login to auto-import your catalog and generate listings from your real product data. Nothing is ever published or edited without your approval, and you can disconnect anytime from Seller Central.
          </p>
        </div>
        <button
          type="button"
          className={styles.connectBtn}
          onClick={() => onConnect && onConnect()}
          disabled={isConnecting}
        >
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7.62881 18.694C5.88759 20.4353 3.04706 20.4353 1.30586 18.6941C-0.435309 16.9529 -0.435289 14.1124 1.30593 12.3712L5.2578 8.4193C6.91778 6.75931 9.57186 6.66763 11.3276 8.1784C11.4971 8.32333 11.6021 8.52966 11.6194 8.752C11.6368 8.97433 11.5651 9.19445 11.4202 9.36395C11.2753 9.53345 11.0689 9.63845 10.8466 9.65583C10.6243 9.6732 10.4041 9.60155 10.2346 9.45662C9.12972 8.50588 7.49722 8.55095 6.44334 9.60483L2.49146 13.5567C1.38653 14.6616 1.38653 16.4036 2.49143 17.5085C3.59634 18.6134 5.33833 18.6134 6.44326 17.5085L10.1975 13.7542C10.275 13.6747 10.3675 13.6115 10.4696 13.5681C10.5718 13.5246 10.6815 13.5019 10.7925 13.5012C10.9035 13.5005 11.0135 13.5219 11.1161 13.564C11.2188 13.6062 11.3121 13.6683 11.3905 13.7468C11.469 13.8252 11.5311 13.9185 11.5733 14.0212C11.6154 14.1238 11.6367 14.2339 11.6361 14.3448C11.6354 14.4558 11.6126 14.5655 11.5692 14.6677C11.5258 14.7698 11.4625 14.8623 11.3831 14.9398L7.62881 18.694ZM14.7422 11.5807C13.0822 13.2406 10.4281 13.3323 8.67239 11.8215C8.58792 11.7499 8.51843 11.6624 8.4679 11.5638C8.41737 11.4653 8.38679 11.3578 8.37793 11.2474C8.36907 11.137 8.3821 11.026 8.41626 10.9207C8.45042 10.8153 8.50505 10.7178 8.57701 10.6336C8.64898 10.5495 8.73685 10.4804 8.83559 10.4303C8.93433 10.3801 9.042 10.35 9.15241 10.3416C9.26282 10.3332 9.3738 10.3468 9.47898 10.3814C9.58416 10.416 9.68147 10.471 9.76531 10.5434C10.8702 11.4941 12.5027 11.449 13.5566 10.3951L17.5085 6.44325C18.6134 5.33832 18.6134 3.59633 17.5085 2.49142C16.4036 1.38652 14.6616 1.38655 13.5567 2.49148L9.80242 6.24574C9.72499 6.32541 9.63249 6.38888 9.5303 6.43249C9.42812 6.47609 9.31828 6.49896 9.20719 6.49975C9.09609 6.50054 8.98595 6.47924 8.88315 6.43709C8.78036 6.39494 8.68697 6.33278 8.60842 6.25422C8.52986 6.17566 8.4677 6.08226 8.42555 5.97947C8.3834 5.87668 8.36209 5.76654 8.36288 5.65545C8.36367 5.54435 8.38653 5.43451 8.43014 5.33233C8.47374 5.23014 8.53722 5.13765 8.61689 5.06021L12.3712 1.30592C14.1124 -0.43529 16.9529 -0.435308 18.6941 1.30587C20.4353 3.04707 20.4353 5.8876 18.694 7.62882L14.7422 11.5807Z" fill="white"/>
          </svg>
          <span>{isConnecting ? 'Connecting...' : 'Sign in with Amazon'}</span>
        </button>
        {onSkip && (
          <button
            type="button"
            className={styles.skipBtn}
            onClick={onSkip}
          >
            Skip for now
          </button>
        )}
        <div className={styles.demoPrompt}>
          <span>Have questions before connecting?</span>
          <button
            type="button"
            className={styles.demoLink}
            onClick={() => setIsDemoOpen(true)}
          >
            Book a free demo
          </button>
          <span>— we'll walk you through it.</span>
        </div>
      </div>
      <BookDemoModal isOpen={isDemoOpen} onClose={() => setIsDemoOpen(false)} />
    </div>
  );
}

export default AmazonSync;
